import { useEffect, useState } from 'react'

export const useWidgetTourHostVisibility = (hostElement: HTMLElement | null): boolean => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!hostElement) {
      setIsVisible(false)
      return
    }

    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true)
      return
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(Boolean(entry?.isIntersecting))
    })

    observer.observe(hostElement)

    return () => observer.disconnect()
  }, [hostElement])

  return isVisible
}
